import type { TimberProject, UserRole } from '../types';
import { isDesignerRole } from './userRoles';

/** Architect, engineer, and supplier test logins need a project tie; other test roles already see their hubs. */
export function canGrantSilentQaProjectAccess(role: UserRole | undefined): boolean {
  return isDesignerRole(role) || role === 'engineer' || role === 'supplier';
}

export function qaViewerUidsOf(
  project: Pick<TimberProject, 'qaViewerUids'> | null | undefined,
): string[] {
  return Array.isArray(project?.qaViewerUids)
    ? project!.qaViewerUids.filter((uid): uid is string => typeof uid === 'string' && uid.length > 0)
    : [];
}

/** True when this uid is on the project's silent QA list (not the visible roster). */
export function projectHasSilentQaViewer(
  project: Pick<TimberProject, 'qaViewerUids'> | null | undefined,
  userId: string | undefined,
): boolean {
  if (!userId) return false;
  return qaViewerUidsOf(project).includes(userId);
}

export function withToggledQaViewerUid(
  current: string[] | undefined,
  userId: string,
  enabled: boolean,
): string[] {
  const next = new Set(qaViewerUidsOf({ qaViewerUids: current }));
  if (enabled) next.add(userId);
  else next.delete(userId);
  return Array.from(next);
}
